import {getCachedTableDataSlice, getCachedTableResultSelector} from 'src/hooks/common-data-service/cached-table';

import {accountSearchResultStateSelector} from './account-search-result-state.slice';

import type {ManagedAccountsSearchCriteria} from '../typedef';
import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {AccountSearchFiltering} from 'src/openapi/admin/models/AccountSearchFiltering';
import type {AccountSortField} from 'src/openapi/admin/models/AccountSortField';
import type {GetManagedAccountIdsRequestFilters} from 'src/openapi/admin/models/GetManagedAccountIdsRequestFilters';


export const accountSearchResultCrmUsersSlice = getCachedTableDataSlice<
    Record<string, number>,
    ManagedAccountsSearchCriteria,
    AccountSortField,
    GetManagedAccountIdsRequestFilters & AccountSearchFiltering
>('assignedAccountsSearchResultCrmUsers');

export const accountSearchResultCrmUsersActions = accountSearchResultCrmUsersSlice.actions;

const accountSearchResultCrmUsersCacheSelector: CachedTableCacheSelector<Record<string, number>>
    = state => state.userPage.tabs.assignedAccounts.crmUsers.cache;
export const accountSearchResultCrmUsersDataSelector: CachedTableDataSelector<Record<string, number>>
    = state => state.userPage.tabs.assignedAccounts.crmUsers;
export const accountSearchResultCrmUsersResultSelector = getCachedTableResultSelector(
    accountSearchResultCrmUsersCacheSelector,
    accountSearchResultStateSelector,
);
